import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IonCheckbox } from '@ionic/angular/standalone';

/** Row item for {@link FormCheckboxGroupComponent}. */
export interface FormCheckboxGroupItem {
  id: string;
  title: string;
  description?: string | null;
}

/**
 * Outlined checkbox list matching Contact / outline field styling.
 * Selection is controlled by the parent via `selectedIds` and `(selectionChange)`.
 */
@Component({
  selector: 'crowdctrl-form-checkbox-group',
  standalone: true,
  imports: [IonCheckbox],
  templateUrl: './form-checkbox-group.component.html',
  styleUrls: [
    '../form-outline-field-tokens.css',
    './form-checkbox-group.component.css',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class FormCheckboxGroupComponent {
  @Input() items: FormCheckboxGroupItem[] = [];
  /** IDs that are currently selected (compare with `===` to `item.id`). */
  @Input() selectedIds: readonly string[] = [];
  @Input() emptyMessage = 'None available.';
  @Input() disabled = false;
  @Input() ariaLabel = 'Selectable options';

  @Output() selectionChange = new EventEmitter<{ id: string; selected: boolean }>();

  isSelected(id: string): boolean {
    return this.selectedIds.includes(id);
  }

  onRowClick(event: MouseEvent, item: FormCheckboxGroupItem): void {
    if (this.disabled) {
      return;
    }
    if ((event.target as HTMLElement).closest('ion-checkbox')) {
      return;
    }
    this.selectionChange.emit({ id: item.id, selected: !this.isSelected(item.id) });
  }

  onCheckboxIonChange(item: FormCheckboxGroupItem, ev: CustomEvent<{ checked: boolean }>): void {
    if (this.disabled) {
      return;
    }
    this.selectionChange.emit({ id: item.id, selected: !!ev.detail.checked });
  }
}
